<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
    width="80%"
  >
    <div class="card">
      <header class="card-header">
        <div class="title">Select Tasks</div>

        <nav class="breadcrumb has-succeeds-separator" aria-label="breadcrumbs">
          <ul>
            <li :class="{ 'is-active': breadcrumbs.length === 0 }">
              <div
                @click.prevent="goRoot"
                :aria-current="breadcrumbs.length === 0 ? 'page' : null"
              >
                Root
              </div>
            </li>

            <li
              v-for="(crumb, index) in breadcrumbs"
              :key="crumb.folderId"
              :class="{ 'is-active': index === breadcrumbs.length - 1 }"
            >
              <div
                @click.prevent="goToBreadcrumb(index)"
                :aria-current="index === breadcrumbs.length - 1 ? 'page' : null"
              >
                {{ crumb.name }}
              </div>
            </li>
          </ul>
        </nav>
      </header>

      <div class="card-content">
        <b-loading
          :is-full-page="false"
          :active.sync="isLoading"
          :can-cancel="false"
          v-if="isLoading"
        />
        <TasksDisplayGrid
          ref="tasksDisplayGridRef"
          :tasks="tasks"
          :show-completeness="true"
          @task-click="onTaskClick"
          :selectMode="true"
          :preSelectedTasks="preSelectedTasks"
        />
      </div>

      <footer class="modal-card-foot">
        <b-button @click="onClose">Close</b-button>
        <b-button type="is-success" @click="onSave">Save</b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import client from '../../../config/api';
import TasksDisplayGrid from './TasksDisplayGrid';

export default {
  name: 'TaskSelectModal',
  components: {
    TasksDisplayGrid,
  },

  props: {
    preSelectedTasks: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      tasks: [],
      currentFolderId: null,
      breadcrumbs: [],
      isLoading: false,
    };
  },

  computed: {
    currentJob() {
      return this.$store.state.JobsModule.currentJob;
    },
  },

  async mounted() {
    this.getTasks();
  },

  methods: {
    onSave() {
      const { selectedTasks } = this.$refs.tasksDisplayGridRef;
      this.$emit('save', [...selectedTasks]);
      this.onClose();
    },

    onClose() {
      this.$emit('close');
    },

    async getTasks() {
      const currentTask = this.breadcrumbs.length
        ? this.breadcrumbs[this.breadcrumbs.length - 1]
        : null;

      let options;
      if (currentTask) {
        options = {
          params: {
            folderId: currentTask.folderId,
          },
        };
      }
      try {
        this.isLoading = true;
        const result = await client.get(
          `/task/job/${this.currentJob._id}`,
          options
        );
        this.tasks = result.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    onTaskClick(task) {
      if (task.taskType === 'folder') {
        this.currentFolderId = task._id;
        const newBreadcrumb = {
          name: task.taskName,
          folderId: task._id,
        };
        this.breadcrumbs.push(newBreadcrumb);
        this.getTasks();
      }
    },

    goRoot() {
      this.currentFolderId = null;
      this.breadcrumbs = [];
      this.getTasks();
    },

    goToBreadcrumb(index) {
      this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
      this.currentFolderId = this.breadcrumbs[index].folderId;
      this.getTasks();
    },
  },
};
</script>

<style scoped lang="scss">
.card {
  border-radius: 10px;
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
}

.breadcrumb {
  margin-top: 4px;
  margin-bottom: 0;
  font-size: 18px;
  width: 100%;

  ul {
    flex-wrap: wrap;
  }

  li {
    div {
      padding: 0 8px;
      cursor: pointer;
      color: #4a90d9;
      border-radius: 4px;
      transition: background-color 0.15s ease, color 0.15s ease;

      &:hover {
        background-color: #f0f4ff;
        color: #2c6fad;
      }
    }

    &.is-active div {
      cursor: default;
      color: #363636;
      font-weight: 600;
      pointer-events: none;

      &:hover {
        background-color: transparent;
      }
    }

    &:first-child div {
      padding-left: 0;
    }
  }
}

.modal-card-foot {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}
</style>
